"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2771],{

/***/ 52771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SectionTermly": function() { return /* binding */ SectionTermly; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55022);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45847);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_2__);



const TermlyEmbed = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    marginTop: "$96",
    minHeight: "100vh"
});
const SectionTermly = (param)=>{
    let { termlyId  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_2___default()), {
                src: "https://app.termly.io/embed-policy.min.js",
                strategy: "afterInteractive"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TermlyEmbed, {
                //@ts-expect-error
                name: "termly-embed",
                "data-id": termlyId,
                "data-type": "iframe"
            })
        ]
    });
};


/***/ })

}]);